import React, { ReactNode } from "react";
import { useSpring, animated } from "@react-spring/web";
import useMeasure from "react-use-measure";

interface CollapsibleProps {
  isOpen: boolean;
  children: ReactNode;
  customStyles?: React.CSSProperties;
  config?: any;
}

// can we make this a common animationcomponent? and isthere a way to make it using usetransitions?
const Collapse: React.FC<CollapsibleProps> = ({
  isOpen,
  children,
  customStyles,
  config,
}) => {
  const [containerRef, containerBounds] = useMeasure();
  const defaultConfig = { tension: 200, friction: 40, mass: 3 };
  
  const [childrenAnimation] = useSpring({
    opacity: isOpen ? 1 : 0,
    height: isOpen ? containerBounds.height : 0,
    from: { opacity: 0, height: 0 },
    config: {
      ...defaultConfig,
      ...config,
    }
  }, [isOpen, containerBounds]);

  return (
    <animated.div style={{
      ...childrenAnimation,
      ...customStyles
    }}>
      <div ref={containerRef}>
        {isOpen ? children : <></>}
      </div>
    </animated.div>
  );
};

export default Collapse;
